var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportactive = function SvgReportactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.008,
    height: 18.008,
    x: 2.997,
    y: 2.996,
    fill: "url(#reportactive_svg__a)",
    strokeWidth: 1.5,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.41,
    d: "M7.498 14 10 11.334 12.5 14l4.002-4.002"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reportactive_svg__a",
    x1: 12,
    x2: 12,
    y1: 2.996,
    y2: 21.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })))));
};
export { SvgReportactive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDU3OTk0NjYwZDNiMTIyZDQ3NTJjOTVhNDNlOThhNDIuc3ZnIjs=";